import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { quotation, recibeQuotation, initiatePayment, confirmPayment, modifyTransaction } from '../services/transaction'
import { handleMinikit } from '../services/users'
import { setUserData, handleMinikitUser } from './userSlice';
import { setBankData } from './bankSlice';

export const initiatePaymentWLD =  createAsyncThunk('transaction/initiatePayment', async (args, { getState }) => {
    const response = await initiatePayment({});
    return { response: response.data, statusCode: response.status };
});

export const recibeQuotWld =  createAsyncThunk('transaction/recibeQuotation', async (args, { getState }) => {
    const response = await recibeQuotation({});
    return { response: response.data, statusCode: response.status };
});

export const confirmPaymentWLD =  createAsyncThunk('transaction/confirmPayment', async (args, { getState }) => {
    const response = await confirmPayment({
        ...args
    });
    return { response: response.data, statusCode: response.status };
});

export const generateQuotation = createAsyncThunk('transaction/quotation', async (args, { getState }) => {
    const { transaction } = getState();
    const response = await quotation({
        currency: args.currency
    });
    return { response: response.data, statusCode: response.status };
});

// Action creators are generated for each case reducer function
export const transactionSlice = createSlice({
    name: 'transaction',
    initialState: {
        currency: { value: "", error: true },
        idTransaction: { value: "", error: true },
        amount: { value: 0, error: true },
        qrPayment: { value: 0, error: true },
        fiatRecibe: { value: 0, error: true },
        commission: { value: 0, error: true },
        commissionBank: { value: 0, error: true },
        commissionAtm: { value: 0, error: true },
        commissionPos: { value: 0, error: true },
        commissionKiosco: { value: 0, error: true },
        rateCrypto: { value: 0, error: true },
        rateCountry: { value: 0, error: true },
        staticFee: { value: 0, error: true },
        total: { value: 0, error: true }, // this is WLD amount
        buttonEnabled: false,
        hash: { value: '', error: true },
        reference: { value: '', error: true },
        payment: { value: false, error: true },
        paymentStatus: { value: '', error: true },
        paymentId: { value: '', error: true },
        discountCodeTrx: { value: "", error: true },
        porcentDiscountCode: { value: 0, error: true },
    },
    reducers: {
        setCurrency: (state, action) => { state.currency = action.payload },
        setTotalAmount: (state, action)=>{state.amount = action.payload},
        setQrTransaction: (state, action)=>{state.qrPayment = action.payload},
        setExRateCrypto: (state, action)=>{state.rateCrypto = action.payload},
        setExRateCountry: (state, action)=>{state.rateCountry = action.payload},
        setFiatRecibe: (state, action)=>{state.fiatRecibe = action.payload},
        setCommission: (state, action)=>{state.commission = action.payload},
        setCommissionBank: (state, action)=>{state.commissionBank = action.payload},
        setCommissionAtm: (state, action)=>{state.commissionAtm = action.payload},
        setCommissionPos: (state, action)=>{state.commissionPos = action.payload},
        setCommissionKiosco: (state, action)=>{state.commissionKiosco = action.payload},
        setStaticFee: (state, action)=>{state.staticFee = action.payload},
        setTotalDeposit: (state, action)=>{state.total = action.payload},
        setButtonEnabled: (state, action) => { state.buttonEnabled = action.payload; },
        setPayment: (state, action) => { state.payment = action.payload },
        setHash: (state, action) => { state.hash = action.payload },
        setReference: (state, action) => { state.reference = action.payload },
        setIdTransaction: (state, action) => { state.idTransaction = action.payload },
        setPaymentStatus: (state, action) => { state.paymentStatus = action.payload },
        setPaymentId: (state, action) => { state.paymentId = action.payload },
        setTrxDiscountCode: (state, action) => { state.discountCodeTrx = action.payload },
        setPorcentTrxDiscountCode: (state, action) => { state.porcentDiscountCode = action.payload }
    },
})

export const { setPayment, setHash, setTotalAmount, setQrTransaction, setExRateCrypto, setExRateCountry, setFiatRecibe, setCommission, setCommissionBank, setCommissionAtm, setCommissionPos, setCommissionKiosco, setTotalDeposit, 
                setButtonEnabled, setStaticFee, setCurrency, setIdTransaction, setReference, setPaymentStatus, setPaymentId, setTrxDiscountCode, setPorcentTrxDiscountCode } = transactionSlice.actions
export default transactionSlice.reducer